import React, { Fragment, useEffect } from "react";
import { Link } from "react-router-dom";
import { useAlert } from "react-alert";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { useDispatch, useSelector } from "react-redux";
import {
  getImageNotifications,
  deleteImageNotificationData,
} from "../../../actions/adminImageNotificationActions";
import Loader from "../../Loader";
import { imageNotificationUrl } from "../../../utils/assets";
import { hasPermission, PERMISSIONS } from "../../../utils/permissions";

const ListImageNotifications = ({ history }) => {
  const alert = useAlert();
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.auth);

  const handleDelete = (id) => {
    confirmAlert({
      title: "Confirm to submit",
      message: "Are you sure you want to delete this notification?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            dispatch(deleteImageNotificationData(id));
            alert.success("Image notification deleted successfully");
            dispatch(getImageNotifications());
          },
        },
        {
          label: "No",
          onClick: () => alert.success("No data deleted"),
        },
      ],
    });
  };

  useEffect(() => {
    dispatch(getImageNotifications());
  }, [dispatch]);

  const { notifications, loading } = useSelector(
    (state) => state.imageNotificationList
  );

  return (
    <Fragment>
      {loading ? (
        <Loader />
      ) : (
        <Fragment>
          <div className="content-wrapper">
            <section className="content-header">
              <h1>
                Manage
                <small> Image Notifications</small>
              </h1>
              <ol className="breadcrumb">
                <li>
                  <Link to="/admin">
                    <i className="fa fa-dashboard"></i> Dashboard
                  </Link>
                </li>
                <li className="active">Image Notifications</li>
              </ol>
            </section>

            <section className="content">
              <div className="box box-default">
                <div className="box-header with-border">
                  <h3 className="box-title">Image Notifications</h3>
                  <div className="box-tools pull-right">
                    {hasPermission(user, PERMISSIONS.IMAGE_NOTIFICATION_CREATE) && (
                      <Link
                        to="/admin/image-notifications/add"
                        className="btn btn-primary btn-sm"
                      >
                        <i className="fa fa-plus"></i> Add Notification
                      </Link>
                    )}
                  </div>
                </div>
                <div className="box-body">
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped">
                      <thead>
                        <tr>
                          <th style={{ width: "60px" }}>#</th>
                          <th>Image</th>
                          <th>Title</th>
                          <th>Link</th>
                          <th>Scrolling Text</th>
                          <th>Location</th>
                          <th>Status</th>
                          <th style={{ width: "150px" }}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {notifications && notifications.length > 0 ? (
                          notifications.map((item, index) => (
                            <tr key={item._id}>
                              <td>{index + 1}</td>
                              <td>
                                {item.image ? (
                                  <img
                                    src={imageNotificationUrl(item.image)}
                                    alt={item.title}
                                    style={{
                                      width: "80px",
                                      height: "60px",
                                      objectFit: "cover",
                                      borderRadius: "4px",
                                    }}
                                  />
                                ) : (
                                  <span className="text-muted">No image</span>
                                )}
                              </td>
                              <td>{item.title}</td>
                              <td>
                                {item.link ? (
                                  <a
                                    href={item.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {item.link.length > 30
                                      ? item.link.substring(0, 30) + "..."
                                      : item.link}
                                  </a>
                                ) : (
                                  <span className="text-muted">-</span>
                                )}
                              </td>
                              <td>
                                {item.message ? (
                                  <span title={item.message}>
                                    {item.message.length > 30
                                      ? item.message.substring(0, 30) + "..."
                                      : item.message}
                                  </span>
                                ) : (
                                  <span className="text-muted">-</span>
                                )}
                              </td>
                              <td>
                                <span
                                  className={`label label-${
                                    item.displayLocation === "both"
                                      ? "primary"
                                      : item.displayLocation === "landing"
                                      ? "info"
                                      : "warning"
                                  }`}
                                >
                                  {item.displayLocation}
                                </span>
                              </td>
                              <td>
                                {item.active ? (
                                  <span className="label label-success">
                                    Active
                                  </span>
                                ) : (
                                  <span className="label label-danger">
                                    Inactive
                                  </span>
                                )}
                              </td>
                              <td>
                                {hasPermission(user, PERMISSIONS.IMAGE_NOTIFICATION_EDIT) && (
                                  <Link
                                    to={`/admin/image-notifications/edit/${item._id}`}
                                    className="btn btn-warning btn-sm"
                                    style={{ marginRight: "5px" }}
                                  >
                                    <i className="fas fa-edit"></i>
                                  </Link>
                                )}
                                {hasPermission(user, PERMISSIONS.IMAGE_NOTIFICATION_DELETE) && (
                                  <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => handleDelete(item._id)}
                                  >
                                    <i className="fas fa-trash-alt"></i>
                                  </button>
                                )}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="8" className="text-center">
                              No image notifications found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

export default ListImageNotifications;
